import React from "react";
import { Todo, actions } from "./store";

interface Props extends Todo {
  editing: boolean;
}

export default function TodoItem(todo: Props) {
  return (
    <li key={todo.id}>
      <input
        className="check"
        type="checkbox"
        checked={todo.complete}
        onChange={() => actions.toggleTodo(todo.id)}
      />
      <span className="name" onDoubleClick={() => actions.editTodo(todo.id)}>
        {todo.editing ? (
          <input
            className="edit"
            autoFocus
            onChange={e =>
              actions.updateTodo(todo.id, {
                id: todo.id,
                task: e.currentTarget.value,
                complete: todo.complete
              })
            }
            onKeyDown={e => {
              if (e.keyCode === 13) {
                actions.editTodo(-1);
              }
            }}
            value={todo.task}
          />
        ) : (
          todo.task
        )}
      </span>
      <button className="close" onClick={() => actions.removeTodo(todo.id)}>
        ×
      </button>
    </li>
  );
}
